import React, { Component } from "react";

export class Footer extends Component {
  render() {
    return (
      <footer className="gatewayfooter footer container">
        Copyright © {new Date().getFullYear()} Canada Health Infoway. All rights
        reserved.
        <br />
        <a href="https://ic.infoway-inforoute.ca/en/about/tou">
          Terms of Use and License Agreements
        </a>
        {". "}
        <a
          href="https://www.infoway-inforoute.ca/en/privacy-policy"
          target="_blank"
        >
          Privacy Policy
        </a>
        {". "}
      </footer>
    );
  }
}
